module.exports = __webpack_public_path__ + "img/img-header-mobile.1ef6e9a.webp";